
      import API from "!../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../style-loader/dist/runtime/styleDomAPI.js";
      
      import setAttributes from "!../../../../../style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./spinner.scss";
      
      

var options = {"attributes":{"id":"@playkit-js/ui-managers"}};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = function (styleElement) {
    if (window.kalturaGlobalConfig && typeof window.kalturaGlobalConfig.stylesNonce === 'string') {
        styleElement.setAttribute('nonce', window.kalturaGlobalConfig.stylesNonce);
    }
    document.head.appendChild(styleElement);
};
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./spinner.scss";
       export default content && content.locals ? content.locals : undefined;
